import React from 'react';
import { Box } from '@mui/material';
import Footer from './Footer';

// Same scroll-containment as AppLayout, for routes with no header/sidebar
// (login, password reset, terms) — keeps the global footer visible everywhere.
const PublicLayout = ({ children }) => (
  <Box sx={{ height: '100vh', overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
    <Box sx={{ flex: 1, overflowY: 'auto', display: 'flex', flexDirection: 'column' }}>
      <Box sx={{ flex: 1 }}>
        {children}
      </Box>
      <Footer />
    </Box>
  </Box>
);

export default PublicLayout;
